module.exports = __webpack_public_path__ + "media/components/src/assets/images/shopping_cart/img-check-c63941b6e3b35f97f7819434cb9c4c94.svg";